import { PaginatedAPIAddressbookContacts } from "../../core/services";
import { ContactSearchLabel, ContactSearchOptions } from "../models/contacts.model";

export const EMPTY_CONTACT_RESULT: PaginatedAPIAddressbookContacts = { 
  content: [],
  pageable: { 
    page_number: 0,
    offset:0, 
    page_size: 0, 
    paged: true, 
    sort: {
      empty: true,
      sorted: false,
      unsorted: true
    }, 
    unpaged: false 
  },
  last: true ,
  total_elements: 0,
  total_pages: 0,
  empty: true,
  size: 20,
  number: 0,
  number_of_elements: 0,
  first: true,
  sort: {
    empty: true,
    sorted: false,
    unsorted: true
  }
};

export const ContactSearchOptionsList: ContactSearchOptions[] = [
    {
      label: ContactSearchLabel.FULL_NAME,
      icon: 'icon-small-user'
    },
    {
      label: ContactSearchLabel.PHONE_NUMBER,
      icon: 'icon-small-handset'
    }
  ];